import axios from '@/libs/api.request'

const userApi = {
  Info: '/user.do/info',
  SubInfo: '/user.do/sub/info'
}

export function getUserToken () {
  return axios.request({
    url: userApi.Info,
    method: 'get'
  })
}

export function updateUserToken (parameter) {
  return axios.request({
    url: userApi.Info,
    data: parameter,
    method: 'put'
  })
}

export function getUserSubInfo () {
  return axios.request({
    url: userApi.SubInfo,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/libs/user.js